export default __webpack_public_path__ + "images/0fc9c00d14541b2fe3d19ee14fe3407a.png";